import { render, staticRenderFns } from "./allUploadsFileInfo.vue?vue&type=template&id=15c526a6&scoped=true&"
import script from "./allUploadsFileInfo.vue?vue&type=script&lang=js&"
export * from "./allUploadsFileInfo.vue?vue&type=script&lang=js&"
import style0 from "./allUploadsFileInfo.vue?vue&type=style&index=0&id=15c526a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c526a6",
  null
  
)

export default component.exports